import { VFC } from "react";
import { Col, Row } from "antd";
import useCookie from "react-use-cookie";
import { CookieCard } from "./CookieCard";
import { OurLayoutForNormalPages } from "../OurLayout";

type Props = {
  datenschutzUrl: string;
  allAcceptedComp: React.ReactElement;
  someAcceptedComp: React.ReactElement;
  cookieName: string;
};

export const CookieConsent: VFC<Props> = ({
  cookieName,
  allAcceptedComp,
  someAcceptedComp,
}) => {
  const [cookieValue, setCookieValue] = useCookie(cookieName, undefined);

  if (cookieValue === "all") {
    return allAcceptedComp;
  }
  return (
    <OurLayoutForNormalPages>
      <Row justify={"center"} style={{ width: "100%" }}>
        {cookieValue === "some" && someAcceptedComp}
        <Col md={24} lg={18} sm={24}>
          <CookieCard onChangeCookieValue={setCookieValue} />
        </Col>
      </Row>
    </OurLayoutForNormalPages>
  );
};
